export const ageGroupChoices = [
    {
      id: 1,
      name: "Child",
      isSelected:false,
    },
    {
      id: 2,
      name: "Teen",
      isSelected:false,
    },
    {
      id: 3,
      name: "Adult",
      isSelected:false,
    },
  ];

  export const childGradeLvl = [
    {
        grade:1,
    },
    {
        grade:2
    },
    {
        grade:3
    },
    {
        grade:4
    },
    {
        grade:5
    },
    {
        grade:6
    },
    {
        grade:7
    },
  ];
  export const teenGradeLvl = [
    {
        grade:8
    },
    {
        grade:9
    },
    {
        grade:10
    },
    {
        grade:11
    },
    {
        grade:12
    },
  ]
  export const bookObj = {
    ageGroup: "",
    level: "",
    title: "",
    author: "",
    image: "",
    paragraph: [],
  };
export const getEndpointByGrade = (grade) => {
    if (grade === 0) return '/book/adults';
    if (grade <= 7) return "/book/children";
    else if (grade >= 8 && grade <= 12) return "/book/teen";
    else return '/book/adults';
};
export const getEndPointByAgeGroup = (ageGroupOpt) => {
    const { name } = ageGroupOpt;
    if (name === 'Child') return '/book/children';
    if (name === 'Teen') return '/book/teen';
    else return '/book/adults';
};

export const getGutenbergEndPointByAgeGroup = (ageGroup, sortBy, page, pageSize) => 
    `/books?topic=${ageGroup}` +
  `&languages=en` +
  `&sort=${sortBy}` +
  `&page=${page}` +
  `&page_size=${pageSize}`;


export const getEndpointBySearchQuery = (query, page, pageSize) => 
   `/books?search=${encodeURIComponent(query)}` +
  `&page=${page}` +
  `&page_size=${pageSize}`;

export const userInfo = {
    createdAt:"",
    userId:"",
    name:"",
    email:"",
    role:"",
    active:""
}